import { initializeKindeClient, checkUserSession, handleLogin, fetchUserData, saveUserData } from './auth/kindeClient';
import { initializeGame } from './gameplay/game';
import { updateStats } from './ui/stats';
import { showUsernameModal, showAccessCodeModal, showBoostModal, hideAllModals } from './ui/modals';
import { showShopPage, hideShopPage } from './ui/shop';
import { displayLoggedInView, displayLoggedOutView, setUser, getUser } from './ui/views';
import { attachEventListeners } from './ui/eventListeners';
import { initButtonTheme } from './ui/settings';
import { installUiSounds } from './ui/uiSounds';
import { installTestHooks } from './debug/testHooks';
import { installTelemetry } from './telemetry';

document.addEventListener('DOMContentLoaded', async function () {
    // Install error capture first so any subsequent boot failure shows
    // up in the local error buffer (localhost: window.__snordeluxeErrors()).
    installTelemetry();
    initButtonTheme();
    installUiSounds();
    installTestHooks();
    // Wire up click handlers BEFORE awaiting any network calls so the Play
    // button is responsive from the moment it renders. The handlers will
    // wait for Kinde to finish initializing internally.
    attachEventListeners();
    // Kick off Kinde init without blocking listener attachment.
    initializeKindeClient();
    const currentUser = await checkUserSession();
    setUser(currentUser);
    updateUIBasedOnUser();
});

function updateUIBasedOnUser() {
    const user = getUser();
    console.log("Updating UI based on user session");
    if (user && user.id) {
        displayLoggedInView();
    } else {
        displayLoggedOutView();
    }
}
